import { Account } from '@starsoft/common/models';

export function isValidChainId(account: Account, chainId?: string): boolean {
  if (!chainId) {
    return false;
  }

  if (account?.coin?.chain?.id?.toString() === chainId) {
    return true;
  }

  return account?.coin?.tokens?.some(
    token => token?.chain?.id?.toString() === chainId,
  );
}
